import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';
import demoBubble from '../../assets/images/demoBubble.png';
import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {Image} from '../common/image';
import {InfoBubble, InfoBubbleInstanceProps} from '../common/infoBubbles/infoBubble';
import {InfoBubbleContent} from '../common/infoBubbles/infoBubbleContent';
import {InfoBubbleDescription} from '../common/infoBubbles/infoBubbleContentDescription';
import {InfoBubbleTitle} from '../common/infoBubbles/infoBubbleContentTitle';
import {InfoBubbleFooterActions} from '../common/infoBubbles/infoBubbleFooterActions';
import {useInfoBubblesContext} from '../common/infoBubbles/infoBubblesContext';

/*
 * Component.
 */

export const GuidedDemoStartInfoBubble: FC<InfoBubbleInstanceProps> = ({targetRef}) => {
  const context = useInfoBubblesContext();
  const onClose = () => context.closeInfoBubbles(OnboardingTipTypesEnum.GUIDED_DEMO_START);

  return (
    <InfoBubble
      {...context}
      type={OnboardingTipTypesEnum.GUIDED_DEMO_START}
      position="left"
      targetRef={targetRef}
      isInteractive
    >
      <InfoBubbleContent>
        <Image src={demoBubble} width={648} height={392} />
        <InfoBubbleTitle>
          <Trans id="infobubble-guideddemostart-title">Look! A new customer email.</Trans>
        </InfoBubbleTitle>
        <InfoBubbleDescription>
          <Trans id="infobubble-guideddemostart-description">
            Let&apos;s say you sell time machines for Quantum Travel Inc, and you need some help on this
            order.
          </Trans>
        </InfoBubbleDescription>
        <InfoBubbleFooterActions>
          <Button
            onClick={onClose}
            size={VisualSizesEnum.MEDIUM}
            color={PaletteColorsEnum.PINK}
            variant={ButtonVariantsEnum.CUSTOM}
          >
            <Trans id="infobubble-guideddemostart-cta">Get started</Trans>
          </Button>
        </InfoBubbleFooterActions>
      </InfoBubbleContent>
    </InfoBubble>
  );
};
